import { MainTheme } from "styled-components";
import "./fonts.css";

export const theme: MainTheme = {
  fonts: {
    heading: `"Beaufort for LOL", sans-serif`,
    body: `"Beaufort for LOL", sans-serif`,
  },
  colors: {
    white: "#FFF",
    offWhite: "#E9EDEB",
    black: "#000",
    magenta: "#CB77BB",
  },
  riotBarHeight: "8rem",
  sectionInnerMaxWidth: "144rem",
  sitePaddingHorizontal: "7.5%",
  gridSpacing: "2.5vw",
  gridSpacingMobile: "5.4vw",
  gridSpacingMax: "4.8rem",
  columnsTotal: 12,
  columnsTotalTablet: 8,
  columnsTotalMobile: 4,
  supportsTextCasing: true,
};
